import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../_hooks/useDialogConfig';
import ClaimViewDialog from '../claim_manage';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import CloseDialogButton from '../../dialogs_common/CloseDialogButton';
import EmptyState, { EmptyStateActions } from '../../components/EmptyState';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { SolidButton } from '../../components/Button';

export default function Launcher(props) {
  const config = useDialogConfig();

  const claim = useConnect('claim.byId', {
    id: config.params.claimId
  });

  if (claim.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (claim.state === PayloadStates.ERROR_FETCHING) {
    return (
      <DialogTemplate className="max-w-screen-lg" overflow={false}>
        <CloseDialogButton onCancel={props.onClose} />
        <EmptyState
          border={false}
          icon={ExclamationTriangleIcon}
          title="You do not have permission to view this invitation."
          subtitle="Only the intended recipient can view this page."
        />
      </DialogTemplate>
    );
  }

  if (claim.state === PayloadStates.NOT_FOUND) {
    return (
      <DialogTemplate className="max-w-screen-lg" overflow={false}>
        <CloseDialogButton onCancel={props.onClose} />
        <EmptyState
          border={false}
          icon={ExclamationTriangleIcon}
          title="Invitation not found."
          subtitle="The offer associated with this invitation no longer exists."
        >
          <EmptyStateActions>
            <SolidButton
              label="Close"
              onClick={props.onClose}
            />
          </EmptyStateActions>
        </EmptyState>
      </DialogTemplate>
    );
  }

  return (
    <ClaimViewDialog
      claim={claim}
      onCancel={props.onClose}
    />
  );
};
